import { callAct, isOk } from './apiConfig';

/*
 * menu — the business's menu (ניהול העסק > תפריט), server-backed + multi-tenant
 * (every act is scoped to the session business). Item shape:
 *   { id, category, name, description, price (whole shekels), sortOrder }
 */

function normalize(row) {
    return {
        id: row.ID ?? row.id,
        category: row.category ?? '',
        name: row.name ?? '',
        description: row.description ?? '',
        price: Number(row.price) || 0,
        sortOrder: Number(row.sortOrder) || 0,
    };
}

// All menu items for the business. Returns [] on error (never throws).
export async function listMenu() {
    try {
        const envelope = await callAct('menuList', {});
        if (isOk(envelope) && Array.isArray(envelope.data)) return envelope.data.map(normalize);
    } catch (e) { /* act unavailable */ }
    return [];
}

// Add an item → { ok, id }.
export async function addItem({ category = '', name, description = '', price = 0, sortOrder = 0 }) {
    try {
        const envelope = await callAct('menuItemAdd', { category, name, description, price, sortOrder });
        return { ok: isOk(envelope), id: envelope?.data?.ID };
    } catch (e) { return { ok: false }; }
}

// Edit an item (send only the fields you want changed; ID + name required) → { ok }.
export async function editItem({ id, ...fields }) {
    try {
        const envelope = await callAct('menuItemEdit', { ID: id, ...fields });
        return { ok: isOk(envelope) };
    } catch (e) { return { ok: false }; }
}

// Soft-delete an item → { ok }.
export async function delItem(id) {
    try {
        const envelope = await callAct('menuItemDel', { ID: id });
        return { ok: isOk(envelope) };
    } catch (e) { return { ok: false }; }
}

export default { listMenu, addItem, editItem, delItem };
